import Api from "@/assets/js/API/api.js";

// :remote-method="(val) => getCustomerList(val, scope.$index)"
// 根据对象类型获取对象的下拉列表
async function getObjectUserDownList(key, name) {
  let resData = "";
  await Api.wtl_getObjectUserDownList({
    key: key,
    name: name,
    pageStart: 1,
    pageTotal: 200,
  })
    .then((res) => {
      resData = res.data.result.data || [];

      // this.$COMAPI.getObjectUserDownList("employee").then(res=>{}); //获取员工列表
      // this.$COMAPI.getObjectUserDownList("dept").then(res=>{}); //获取部门列表
      // this.$COMAPI.getObjectUserDownList("storage").then(res=>{}); //获取网点列表
    })
    .catch((error) => {});

  return resData;
}

// 根据字典类型获取字典值下拉列表
async function getConfDictValDownList(dictType) {
  let resData = "";
  await Api.wtl_getConfDictValDownList({
    dictType: dictType,
  })
    .then((res) => {
      resData = res.data.result || [];
      // 调用
      // this.$COMAPI.getConfDictValDownList("package_name").then(res=>{}); //获取包装
      // this.$COMAPI.getConfDictValDownList("waybill_type").then(res=>{}); //货物类型
      // this.$COMAPI.getConfDictValDownList("rn_order_require").then(res=>{}); //回单类型
      // this.$COMAPI.getConfDictValDownList("send_method").then(res=>{}); //送货方式
      // this.$COMAPI.getConfDictValDownList("receive_method").then(res=>{}); //提货方式
      // this.$COMAPI.getConfDictValDownList("transport_method").then(res=>{}); //运输方式
      // this.$COMAPI.getConfDictValDownList("settlement_method").then(res=>{}); //付款方式
      // this.$COMAPI.getConfDictValDownList("start_car_check_item").then(res=>{}); //出车检查项
      // this.$COMAPI.getConfDictValDownList("exception_type").then(res=>{}); //异常类型
      // this.$COMAPI.getConfDictValDownList("handling_order_type").then(res=>{}); //装卸类型
      // this.$COMAPI.getConfDictValDownList("settlement_method").then(res=>{}); //获取付款方式
      // this.$COMAPI.getConfDictValDownList("object_status").then(res=>{}); //获取结算对象类型
      // this.$COMAPI.getConfDictValDownList("insurance_type").then(res=>{}); //险种
      // this.$COMAPI.getConfDictValDownList("customer_level").then(res=>{}); //客户等级

      //     <el-option
      //     v-for="(item, index) in handling_order_type_list"
      //     :key="index"
      //     :label="item.key"
      //     :value="item.confDictId"
      //   ></el-option>
    })
    .catch((error) => {});

  return resData;
}
// 获取品类
async function getCategoryList(categoryName) {
  let resData = "";
  await Api.wtl_getConfDictValDownList({
    categoryName: categoryName,
    pageStart: 1,
    pageTotal: 200,
  }).then((res) => {
    resData = res.data.result.data || [];
  });
  return resData;
}
// 获取客户列表
async function getCustomerList(name) {
  let resData = "";
  await Api.wtl_getObjectUserDownList({
    key: "customer",
    name: name || "",
    pageStart: 1,
    pageTotal: 200,
  }).then((res) => {
    resData = res.data.result.data || [];
  });
  return resData;
}
// 根据上级名称查询省市区
async function getParentName(e) {
  // e='中华人民共和国'
  let resData = "";
  await Api.wtl_getDistrictList({
    pageStart: 1,
    pageTotal: 100,
    parentName: e,
  }).then((res) => {
    resData = res.data.result.data || [];
  });
  return resData;
}

// 承运商列表
async function changeCarrier(carrierName) {
  let resData = "";
  await Api.CarrierList({
    pageStart: 1,
    pageTotal: 200,
    carrierName: carrierName || "",
  }).then((res) => {
    resData = res.data.result.data || [];
  });
  return resData;
}

// 承运商网点
async function CarrierDeptList(carrierId) {
  let resData = "";
  await Api.CarrierDeptList({
    pageStart: 1,
    pageTotal: 200,
    carrierId: carrierId || "",
  }).then((res) => {
    resData = res.data.result.data || [];
  });
  return resData;
}

// 获取组织架构列表
async function getDeptList(p) {
  let params = {
    pageStart: 1,
    pageTotal: 200,
  };
  let resData = "";
  await Api.wtl_getDeptList(params).then((res) => {
    resData = res.data.result.data || [];
  });
  return resData;
}

// 导出数据  (表头字段,列表标识,列表数据,表名)
function dynamicExport(myTableHeard, className, tableData, sheetName) {
  let heads = myTableHeard;
  let tableDatas = tableData || "";
  let newHeads = [];
  for (var i = 0; i < heads.length; i++) {
    let objs = {
      fieldKey: heads[i].field,
      title: heads[i].name,
    };
    newHeads.push(objs);
  }
  let param = {
    className: className || "",
    data: JSON.stringify(tableDatas),
    head: newHeads,
    sheetName: sheetName || "表名",
  };
  Api.dynamicExport(param).then((res) => {
    let downloadurl = res.data.result.fileUrl || "";
    //下载(这里其实是直接访问)
    var a = document.createElement("a");
    a.setAttribute("href", downloadurl);
    a.setAttribute("target", "_blank");
    a.download = sheetName;
    a.click();
    // 一次性的,用完就删除a标签
    a.remove();

    // 兼容ie
    // if ('ActiveXObject' in window) {
    //     // ie浏览器没有解决
    //     // 网上说navigator.msSaveBlob(blob, filename);如果这句话管用，那下面代码不需要了 这个属性那是blob是哪来的，没有测试
    //     this.createAndRemove(downloadurl, sheetName)   // 实现了ie浏览我的下载，但是没有实现修改文件名的需求
    // } else {
    //     const x = new XMLHttpRequest()
    //     x.open('GET', downloadurl, true)
    //     x.responseType = 'blob'
    //     x.onload = () => {
    //         const downloadurl = window.URL.createObjectURL(x.response)
    //         this.createAndRemove(downloadurl, sheetName)
    //     }
    //     x.send()
    // }
  });
}

// 自定义模板导出
function templateDataExport(customizedExportId, tableData, className) {
  let datas = tableData || [];
  let parm = {
    customizedExportId: customizedExportId, //模板id
    className: className,
    data: datas,
  };
  let signarr = tools.getSignArr(parm);
  let signs_e = tools.getMD5Sign(signarr);

  Api.templateDataExport({
    customizedExportId: customizedExportId,
    className: className,
    data: JSON.stringify(datas),
    sign: signs_e,
  }).then((res) => {
    //下载(这里其实是直接访问)
    let downloadurl = res.data.result.fileUrl;
    var a = document.createElement("a");
    a.style.display = "none";
    a.href = downloadurl;
    a.target = "_blank";
    a.setAttribute("download", "综合查询.xlsx"); //指定下载后的文件名，防跳转
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  });
}
// 点击导出   (页面标识,表头字段,列表标识,列表数据,表名)
function exportBtn(param) {
  let {
    pageGroupName = "",
    myTableHeard = [],
    className = "",
    tableData = [],
    sheetName = "表名",
  } = param;

  let fieldName = [];
  let head = [];
  for (var i = 0; i < myTableHeard.length; i++) {
    if (myTableHeard[i].isShow) {
      fieldName.push(myTableHeard[i].field);
      head.push(myTableHeard[i].name);
    }
  }
  // this.fieldName = fieldName;
  // this.head = head;

  // 1,先获取用户导出模板
  Api.getUserExportTemplate({
    groupName: pageGroupName,
  }).then((res) => {
    if (res.data.result && res.data.result[0].customizedExportId) {
      // 有自定义模板
      let customizedExportId = res.data.result[0].customizedExportId;
      templateDataExport(customizedExportId, tableData, className);
    } else {
      // 没有自定义模板,默认
      dynamicExport(myTableHeard, className, tableData, sheetName);
    }
  });
}

// 动态查询返回字段
async function getReportFiledsAPi(number) {
  await Api.getReportFileds({
    number,
  }).then((res) => {});
}
export default {
  getObjectUserDownList, // 根据对象类型获取对象的下拉列表
  getConfDictValDownList, // 根据字典类型获取字典值下拉列表
  getCategoryList, // 获取品类
  getCustomerList, // 获取客户列表
  getParentName, // 根据上级名称查询省市区
  changeCarrier, // 获取承运商列表
  CarrierDeptList, // 获取承运商网点
  getDeptList, // 业务部门
  exportBtn, //导出
  getReportFiledsAPi,
};
